import axios from "axios";

function configuredRoot() {
  if (localStorage.api) return localStorage.api;
  if (window.FERA_MATTERS_API_URL) return window.FERA_MATTERS_API_URL;
  if (process.env.REACT_APP_API_URL) return process.env.REACT_APP_API_URL;
  return "/";
}

export function normalizeRoot(url) {
  const value = String(url || "").trim().replace(/^['"]+|['";]+$/g, "").trim();
  if (!value) return "/";
  if (value.startsWith("/")) return value.endsWith("/") ? value : `${value}/`;

  const rooted = /^https?:\/\//i.test(value)
    ? value
    : /^(localhost|127\.0\.0\.1|\[::1\])(?::|\/|$)/i.test(value)
      ? `http://${value}`
      : `https://${value}`;

  return rooted.endsWith("/") ? rooted : `${rooted}/`;
}

export function setSignatureApiRoot(url) {
  const value = normalizeRoot(url);
  localStorage.setItem("api", value);
  return value;
}

export function signatureApiRoot() {
  return normalizeRoot(configuredRoot());
}

function signatureApiBase() {
  const clean = signatureApiRoot().replace(/\/+$/, "");
  if (clean.endsWith("/api") || clean.endsWith("/api/v1")) return clean;
  return `${clean}/api`;
}

export function publicDocumentUrl(token, documentUuid) {
  return `${signatureApiBase()}/public/sign/${encodeURIComponent(token)}/documents/${encodeURIComponent(documentUuid)}/content`;
}

const signatureApi = axios.create({
  headers: {
    "Content-Type": "application/json"
  }
});

signatureApi.interceptors.request.use(
  cfg => {
    cfg.baseURL = signatureApiBase();
    if (localStorage.instance) cfg.headers["instance"] = localStorage.instance;
    return cfg;
  },
  err => Promise.reject(err)
);

export default signatureApi;
